module.exports = __webpack_public_path__ + "static/img/evaluation.36412497.png";